import { Component, input, OnInit } from '@angular/core';

import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatHint } from "@angular/material/form-field";

@Component({
  selector: 'admin-controller',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    MatHint
],
  templateUrl: './admin-controller.component.html',
  styleUrl: './admin-controller.component.scss'
})
export class AdminControllerComponent implements OnInit {
  parentForm = input.required<FormGroup>();
  label = input.required<string>();

  ngOnInit(): void {
    // Ensure controls exist in parentForm (if not already added)
    if (!this.parentForm().get('isEnabled')) {
      this.parentForm().addControl('isEnabled', new FormControl<boolean>(true));
    }
    if (!this.parentForm().get('isUniversal')) {
      this.parentForm().addControl('isUniversal', new FormControl<boolean>(false));
    }
  }
}
